import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getSearchdata } from '../../api'
import img_home from '../../img_4/home.png'
import no_res from '../../img_4/no_res.png'
import starsScore from '../../method/start'
import Footer from '../Home/Footer/Footer'
import './Search.css'

export default function Search() {
  const { search } = useLocation()
  const [searc, setSearc] = useState([])
  const [resdata, setResdata] = useState([])
  const ipref = useRef()

  function getValue() {
    return search.split('=')[1]
  }
  // console.log(getValue());

  // 将要索引的值赋给输入框
  setTimeout(() => {
    ipref.current.value = getValue()
  }, 1)

  // getdata
  const getdata = para => {
    getSearchdata(para).then(res => {
      console.log(res)
      setSearc(res.data.recommend)
      setResdata(res.data.result)
    })
  }

  // 跳转到详情页
  function goDetails(para) {
    window.location = '/page/details?gid=' + para
  }

  // 返回
  const goback = () => {
    /* navigate(-1) */
    window.location = '/'
  }

  // search
  const tosearch = e => {
    let keycode = e.keyCode
    if (keycode === 13 && ipref.current.value !== '') {
      window.location = '/page/search?words=' + ipref.current.value
      getdata('?words=' + ipref.current.value)
    }
  }

  useEffect(() => {
    getdata(search)
  }, [search])

  return (
    <div className="search4">
      <div>
        <div className="sear-head">
          <img src={img_home} alt="" onClick={goback} className="back" />
          <h1>Search</h1>
        </div>

        <div className="search-h">
          <h2>Search Result</h2>
          <div>
            <input type="search" onKeyUp={tosearch} ref={ipref} />
          </div>
        </div>

        {/* 若搜索结果为空 */}
        {/* The game you searched for cannot be found */}
        {resdata.length === 0 ? (
          <div className="no_res">
            <img src={no_res} alt="" />
          </div>
        ) : (
          <div className="res-content">
            {resdata?.map(item => (
              <div key={item.gid} className="newgame_content" onClick={() => goDetails(item.gid)}>
                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                <div className="new_con">
                  <h4>{item.name}</h4>
                  <p className="gametype">
                    {starsScore(item.score)} {item.score}
                  </p>
                  <p className="playnum">{item.count / 1000}k+</p>
                </div>
                <div className="play">PLAY GAME</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="con-list">
        <div className="list_con">
          <h2>Recommend Games</h2>
          {/* 搜索结果列表 */}
          <ul>
            {searc?.map(item => (
              <div key={item.gid} className="newgame_content" onClick={() => goDetails(item.gid)}>
                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                <div className="new_con">
                  <h4>{item.name}</h4>
                  <p className="gametype">
                    {starsScore(item.score)} {item.score}
                  </p>
                  <p className="playnum">{item.count / 1000}k+</p>
                </div>
                <div className="play">PLAY GAME</div>
              </div>
            ))}
          </ul>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}
